import { toast, ToastOptions } from 'react-toastify';

export function showError(message: string, options?: ToastOptions) {
	return toast.error(message, options);
}

export function showSuccess(message: string, options?: ToastOptions) {
	return toast.success(message, options);
}
